<template>
<div class="LampsForm">
  <div
    class="card"
    v-if="lamps.length < this.lampsLeft"
  >
    <div class="card-header">
      <h4 class="card-title">
        <i class="ti-light-bulb"></i> Trocar Nova Lâmpada
      </h4>
      <small>Quantidade de lâmpadas no estoque: {{ this.stock - this.countEventLamps }} - {{ this.countEventLamps }} / {{ this.stock }}</small>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <table class="table">
            <thead>
            <th><label class="control-label">Potência</label></th>
            <th><label class="control-label">Tipo de Lâmpada Recebida</label></th>
            <th><label class="control-label">Cômodo</label></th>
            <th style="width: 12em;"><label class="control-label">Hora em Uso por Dia</label></th>
            <th style="width: 14em;"><label class="control-label">Esta lâmpada foi utilizada em horário de pico?</label></th>
            </thead>
            <tbody>
            <tr>
              <td><select
                name="power"
                v-validate="modelValidations.power"
                v-model="model.power"
                class="form-control"
              >
                <option
                  value="0"
                  disabled
                >Selecione ...
                </option>
                <option
                  v-for="option in options.power"
                  :key="option.value"
                  :value="option.value"
                >{{ option.label }}
                </option>
              </select></td>
              <td><select
                name="type"
                v-validate="modelValidations.type"
                v-model="model.type"
                class="form-control"
              >
                <option
                  value=""
                  disabled
                >Selecione ...
                </option>
                <option
                  v-for="option in options.type"
                  :key="option.value"
                  :value="option.value"
                >{{ option.label }}
                </option>
              </select></td>
              <td><select
                name="room"
                v-validate="modelValidations.room"
                v-model="model.room"
                class="form-control"
              >
                <option
                  value=""
                  disabled
                >Selecione ...
                </option>
                <option
                  v-for="option in options.room"
                  :key="option.value"
                  :value="option.value"
                >{{ option.label }}
                </option>
              </select></td>
              <td><input
                type="number"
                class="form-control"
                name="usageHoursPerDay"
                v-validate="modelValidations.usageHoursPerDay"
                v-model="model.usageHoursPerDay"
                min="1"
                max="24"
              ></td>
              <td>
                <p-switch
                  v-model="model.rushHour"
                  type="primary"
                  on-text="Sim"
                  off-text="Não"
                ></p-switch>
              </td>
            </tr>
            <tr class="helpers-table">
              <td><small
                class="text-danger"
                v-show="power.invalid"
              >{{ getError('power') }}
              </small></td>
              <td><small
                class="text-danger"
                v-show="type.invalid"
              >{{ getError('type') }}
              </small></td>
              <td><small
                class="text-danger"
                v-show="room.invalid"
              >{{ getError('room') }}
              </small></td>
              <td><small
                class="text-danger"
                v-show="usageHoursPerDay.invalid"
              >{{ getError('usageHoursPerDay') }}
              </small></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button
        type="button"
        :disabled="stock <= 0 && lampsLeft >= lamps.length"
        @click.prevent="handleAdd"
        class="btn btn-fill btn-success btn-wd"
      >
        <i class="ti-plus"></i> Adicionar
      </button>
    </div>
  </div>


  <div
    class="card"
    v-if="showResumeTable"
  >
    <div
      class="card-header"
      v-if="showResumeTable"
    >
      <h4 class="card-title">
        <i class="ti-light-bulb"></i> Lâmpadas Adicionadas({{ lamps.length }})
      </h4>
    </div>

    <div
      class="card-content"
      v-if="showResumeTable"
    >
      <div class="row">
        <div class="col-md-12">
          <el-table
            class="table-striped"
            :data="lamps"
          >
            <el-table-column
              label="Potência"
              property="power"
            >
              <template slot-scope="props">{{ props.row.power }}W</template>
            </el-table-column>

            <el-table-column
              label="Tipo de Lâmpada Recebida"
              property="type"
            />
            <el-table-column
              label="Cômodo"
              property="room"
            />
            <el-table-column
              label="Hora em Uso por Dia"
              property="usageHoursPerDay"
            />

            <el-table-column label="">
              <template slot-scope="props">
              <div class="text-right">
                <a
                  class="btn btn-danger btn-fill btn-icon remove"
                  @click="handleRemove(props.$index, props.row)"
                >
                  <i class="ti-trash"></i>
                </a>
              </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>


    <div
      class="card-footer"
      v-if="showResumeTable"
    >
      <div class="row">
        <div class="col-xs-6 text-left">
          <action-term-lamps
            v-if="event.hasOwnProperty('lamp') && event.lamp.requiredTermLamp"
            :event="event"
            :customer="customer"
            :lamps="lamps"
            :eventId="eventId"
            @upload-file="emitUploadFile($event)"
          ></action-term-lamps>
        </div>

        <div
          class="col-xs-6 text-right"
          v-loading="saving"
        >
          <button
            :disabled="eventId === '' || saving"
            type="submit"
            @click="handleSave"
            class="btn btn-fill btn-success btn-wd"
          >

            <i class="ti-save"></i> Salvar

          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vee-validate'
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'
import ActionTermLamps from './ActionTermLamps'
import PSwitch from 'src/components/UIComponents/Switch.vue'

export default {
  name: 'LampsForm',

  components: {
    ActionTermLamps,
    PSwitch
  },

  props: {
    customer: {
      required: true,
      type: Object
    },
    lampsLeft: {
      required: true,
      type: Number
    },
    event: { required: true },
    stockLamps: {
      required: true,
      type: Number
    }
  },

  data () {
    return {
      lamps: [],
      countEventLamps: 0,
      isLoadingFile: false,
      selectedFile: '',
      binaryFiles: [],
      saving: false
    }
  },
  methods: {
    ...mapActions('project', {
      fetchProject: 'fetchOne'
    }),

    ...mapActions('lamps', {
      insert: 'insert',
      setCurrentLampsTmp: 'setCurrentLampsTmp',
      uploadFileLamp: 'uploadFileLamp'
    }),

    ...mapActions(
      'events',
      {
        fetchStartedEvents: 'getStartedEvents',
        fetchOne: 'fetchOne',
        getEvents: 'fetchAll'
      }
    ),

    emitUploadFile (file) {
      this.$nextTick(() => {
        this.binaryFiles.push(file)
      })
    },

    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    handleAdd () {
      this.countEventLamps += 1
      this.$validator.validateAll()
        .then(isValid => {
          if (isValid) {
            this.lamps.push(Object.assign({}, this.model))
          }
        })
    },

    handleRemove (index, row) {
      this.countEventLamps -= 1
      this.lamps.splice(index, 1)
      if (this.lamps.length <= 0) {
        this.resetFile()
      }
    },

    handleSave () {
      if (this.saving) { // Mais uma validação extra para evitar duplicidade
        return false
      }
      this.saving = true
      if (!this.eventId || this.eventId === '') {
        swal({
          text: `Nenhum evento foi selecionado.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        this.saving = false
        return false
      }
      if (this.event.lamp.requiredTermLamp && Array.isArray(this.binaryFiles) && this.binaryFiles === 0) {
        swal({
          text: `Nenhum arquivo foi selecionado.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        this.saving = false
        return false
      }
      this.runSave()
    },

    runSave () {
      let doc = {
        customer: {
          id: this.customer._id,
          uc: this.customer.uc,
          cpf: this.customer.cpf,
          holder: this.customer.holder
        },
        eventId: this.eventId,
        items: this.lamps,
        collection: 'lamps'
      }
      if (this.event.lamp.requiredTermLamp) {
        doc.hasAttachment = true
      }
      this.save(doc)
        .then(() => {
          this.saving = false
          this.resetForm()
          swal({
            title: 'Sucesso!',
            text: 'Aguarde o fim do processamento.',
            type: 'warning'
          })
          location.reload()
        })
        .catch(err => console.log('error saving', err))
    },

    save (doc) {
      return new Promise(async (resolve) => {
        let verification = await this.verifyStock(doc)
        if (verification.allowedDelived >= 0) { // Quantidades para entrega positiva
          resolve(this.insertLamps(doc))
          return
        }

        if (Math.abs(verification.allowedDelived) >= doc.items.length) { // Quantidade de itens ultrapassa o limite
          resolve(this.notAllowAlert())
          return
        }

        resolve(this.moreThanAlert(verification))
      })
    },

    async getCountEventLamps () {
      let result = await Couchdb.view(
        'count-lamps-by-event',
        'count-lamps-by-event',
        this.eventId,
        {
          group: true,
          reduce: true
        }
      )

      let deliveryLamps = result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0
      this.countEventLamps = deliveryLamps
    },

    async verifyStock (doc) {
      await this.getCountEventLamps()
      let currentStockAmount = this.event.numberOfLamps - this.countEventLamps
      let allowedDelived = currentStockAmount - doc.items.length
      return {
        deliveryLamps: this.countEventLamps,
        currentStockAmount,
        allowedDelived
      }
    },

    insertLamps (doc) {
      return this.insert(doc)
        .then(async result => {
          if (this.event.hasOwnProperty('lamp') && this.event.lamp.requiredTermLamp) {
            await this.handleSaveFile(result.id)
          }

          this.finishSave({ error: false })
        })
        .catch(err => console.log(err))
    },

    notAllowAlert () {
      swal({
        title: 'Estoque esgotado!',
        text: 'Não há mais lâmpadas no estoque do evento.',
        type: 'error'
      })
        .then(() => {
          this.finishSave({ error: true })
        })
      return false
    },

    moreThanAlert (verification) {
      swal({
        title: 'Estoque insuficiente!',
        text: `Existem ${verification.currentStockAmount} lâmpadas no estoque.
              Remova ${Math.abs(verification.allowedDelived)} lâmpadas e tente novamente`,
        type: 'info'
      })
      return false
    },

    async handleSaveFile (id) {
      this.isLoadingFile = true

      let docId
      let referenceDoc = await new Promise((resolve) => {
        Couchdb.connection('docs')
        .where('referenceId', id)
        .get()
        .then(async res => {
          let doc = res[0] || false
          if (res.length === 0) {
            doc = await Couchdb.connection('docs')
              .insert({ referenceId: id, collection: 'lamps', database: 'trg_admin' })
          }

          resolve(doc)
        })
      })

      if (referenceDoc) {
        docId = referenceDoc.id

        for (const i in this.binaryFiles) {
          await Couchdb.connection('docs')
            .insertAttachment(docId, {
              attachmentName: this.binaryFiles[i].name,
              mimeType: this.binaryFiles[i].blob.type,
              attachment: this.binaryFiles[i].blob
            })
        }
      }
    },

    finishSave ({ error }) {
      this.isLoadingFile = true
      this.$emit('on-save', {})
      if (error) {
        this.$notify({
          message: `Falha ao adicionar as lâmpadas.`,
          type: 'danger'
        })
      } else {
        this.$notify({
          message: `${this.lamps.length} lâmpada(s) adicionadas com sucesso.`,
          type: 'success'
        })
      }
      this.resetForm()
      this.lamps = []
      this.saving = false
    },

    resetFile () {
      this.isLoadingFile = false
      this.selectedFile = ''
      this.binaryFiles = []
    },

    resetForm () {
      // this.resetLamp()
      // this.resetLamps()

      this.lamps = []
      this.isLoadingFile = false
      this.selectedFile = ''
      this.$emit('fetchData')
      this.resetFile()
    }
  },
  computed: {
    ...mapFields(['type', 'room', 'usageHoursPerDay', 'power']),

    ...mapGetters('lamps', {
      model: 'lamp',
      allLamps: 'allLamps',
      modelValidations: 'validations',
      loading: 'loading',
      options: 'options',
      countLamps: 'count'
    }),

    ...mapGetters('project', {
      config: 'project'
    }),

    ...mapGetters('events', {
      events: 'events'
    }),

    eventId: function () {
      return this.event._id
    },

    showResumeTable () {
      return this.lamps.length > 0
    },

    stock: function () {
      this.getCountEventLamps()
      return this.stockLamps
    }
  },
  mounted () {
    this.resetForm()
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config')
    }
  }
}
</script>
<style scope>
  .helpers-table > td {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Lamps/FormLamps.vue